import BrandLogo, { BrandLogoProps } from './BrandLogo'
import { BRAND_LOGO_SIZE, BRAND_LOGO_TYPES } from './BrandLogo.constants'
export default BrandLogo

export { BrandLogo, BRAND_LOGO_SIZE, BRAND_LOGO_TYPES }
export type { BrandLogoProps }
